import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=3e2c8efa&scoped=true&"
import script from "./GiftCard.vue?vue&type=script&lang=js&"
export * from "./GiftCard.vue?vue&type=script&lang=js&"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=3e2c8efa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c8efa",
  null
  
)

export default component.exports